import { STOModel } from "../../models/base/sto-model";
import { TravelExpenseOrderedSuggestedNotesDTO } from "../../models/travel-expense-suggested-note/travel-expense-ordered-suggested-notes/travel-expense-suggested-note-order-ref";
import { BaseApiService } from "../base";

export class TravelExpenseOrderedSuggestedNotes extends BaseApiService<
  TravelExpenseOrderedSuggestedNotesDTO,
  STOModel
> {
  constructor() {
    super({
      servicePath: "/TravelExpenseSuggestedNotes",
      loadItemsPath: "/GetTravelExpenseOrderedSuggestedNotes",
    });
  }
}
